export enum OperatorDocumentTypeEnum {
  CI = 1,
  D085 = 2,
  OC = 3,
  SC = 4,
  VGHTC = 5,
  MISC = 6
}
